import axios from "axios";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
} from "@mui/material";
import apiUrl from "../../../configs/constant";

import { useForm } from "react-hook-form";

type Props = {
  open: boolean;
  onClose: () => void;
  getContact: () => void;
  token:string
};

type FormType = {
  nama: string;
  nomor_telfon: string;
  text: string;
};

export default function DialogCreateContact({
  open,
  onClose,
  getContact,
  token,
}: Props) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<FormType>({
    defaultValues: {
      nama: "",
      nomor_telfon: "",
      text: "",
    },
  });

  const onSubmit = async (data: FormType) => {
    try {
      await axios.post(
        `${apiUrl.apiUrl}/omni/chat/send-message`,
        data,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
      );

      // success
      getContact();

      reset();
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  const handleClose = () => {
    reset();

    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        Kirim Pesan
      </DialogTitle>

      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            
            {/* NAMA */}
            <TextField
              label="Nama"
              fullWidth
              {...register("nama", {
                required: "Nama wajib diisi",
              })}
              error={!!errors.nama}
              helperText={errors.nama?.message}
            />

            {/* NOMOR TELFON */}
            <TextField
                label="Nomor Telfon"
                fullWidth
                placeholder="628123456789"
                {...register("nomor_telfon", {
                    required: "Nomor telfon wajib diisi",

                    pattern: {
                    value: /^62[0-9]{8,15}$/,
                    message:
                        "Nomor harus angka dan diawali 62",
                    },

                    validate: (value) => {
                    if (!/^\d+$/.test(value)) {
                        return "Nomor hanya boleh angka";
                    }

                    return true;
                    },
                })}
                error={!!errors.nomor_telfon}
                helperText={errors.nomor_telfon?.message}
            />

            {/* TEXT */}
            <TextField
              label="Text"
              fullWidth
              multiline
              rows={4}
              {...register("text", {
                required: "Text wajib diisi",
              })}
              error={!!errors.text}
              helperText={errors.text?.message}
            />
          </Stack>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleClose}
            color="inherit"
          >
            Batal
          </Button>

          <Button
            type="submit"
            variant="contained"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Loading..." : "Simpan"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}